import React, { useEffect, useState } from "react";
import BasicEngineLog from "./child/basic-engine";
import VoyageDetails from "../../../components/VoyageDetails";

function AddEngineLogBook() {
  const [activeTab, setActiveTab] = useState("basic");
  const [staff_dashboard, set_staff_dashboard] = useState([]);

  useEffect(() => {
    const lastSelectedKey = localStorage.getItem("engineLogbook") || activeTab;
    setActiveTab(lastSelectedKey);
  }, []);

  const handleClick = (name) => {
    if (name === "basic") {
      setActiveTab(name);
      localStorage.setItem("engineLogbook", name);
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
  }, []);

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <ul className="marine-tabs">
          <li
            className={activeTab === "basic" ? "active" : ""}
            onClick={() => handleClick("basic")}
          >
            Basic Engine Log
          </li>
          {/* <li className="disabled-tab">Daily consumption</li> */}
          <li className="disabled-tab">Main Engine Log</li>
          <li className="disabled-tab">Auxiliary Engine Log</li>
          <li className="disabled-tab">Auxiliary Machinery</li>
          <li className="disabled-tab">Cargo Machinery</li>
          <li className="disabled-tab">Remarks</li>
        </ul>
        {activeTab === "basic" && <BasicEngineLog />}
      </div>
    </>
  );
}

export default AddEngineLogBook;
